import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Llegas tarde. Estás agotada. Y terminas dándole lo mismo de siempre.', 'Te da miedo que se atragante, así que no cambias la textura.', 'Guardas decenas de reels, pero a la hora de cocinar, te quedas en blanco.', 'Te sientes culpable porque quieres hacerlo mejor, pero el día no te alcanza.', 'Y aunque lo intentas... algo dentro de ti siente que estás improvisando.'];
  return <section className="bg-gradient-to-b from-baby-pink-light to-white py-12 sm:py-16 md:py-20" data-id="element-844">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-845">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-846">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 text-gray-900" data-id="element-847">
            Si Esto Te Resuena, Sigue Leyendo
          </h2>
          <p className="text-base sm:text-lg text-gray-600" data-id="element-848">
            Tal vez te pasa algo de esto...
          </p>
        </div>

        <div className="space-y-4 sm:space-y-5 stagger-children" data-id="element-849">
          {problems.map((problem, index) => <div key={index} className="bg-white/80 backdrop-blur-baby p-4 sm:p-6 rounded-baby-lg border-2 border-baby-pink-light/50 shadow-baby-pink hover:shadow-baby-glow transition-all" data-id="element-850">
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-851">
                <div className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 text-baby-pink mt-0.5" data-id="element-852">
                  <XCircleIcon className="w-full h-full" data-id="element-853" />
                </div>
                <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-854">
                  {problem}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-8 sm:mt-12 text-center animate-fade-in-up" style={{
        animationDelay: '0.6s'
      }} data-id="element-855">
          <p className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-2" data-id="element-856">
            No eres la única. Muchas mamás viven esto.
          </p>
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-857">
            Ese momento que debería ser nutritivo y amoroso, se vuelve:{' '}
            <span className="font-semibold text-baby-pink" data-id="element-858">Estrés</span> ("otra
            vez no sé qué hacer"){' '}
            <span className="font-semibold text-baby-pink" data-id="element-859">Miedo</span> ("¿y si
            se atraganta?"){' '}
            <span className="font-semibold text-baby-pink" data-id="element-860">Culpa</span>{' '}
            ("debería darle algo mejor")
          </p>
          <p className="mt-6 text-lg sm:text-xl md:text-2xl font-bold text-gray-900 italic" data-id="element-861">
            "¿Tiene que ser tan complicado?"
          </p>
        </div>
      </div>
    </section>;
}